module.exports = {"facts":[{"key":"view_f_1_1"},{"key":"view_f_1_2"},{"key":"view_f_1_3"},{"key":"view_f_1_4"},{"key":"view_f_1_5"},{"key":"view_f_1_6"}],"board":[{"key":"view_f_2_1"},{"key":"view_f_2_2"},{"key":"view_f_2_3"},{"key":"view_f_2_4"},{"key":"view_f_2_5"},{"key":"view_f_2_6"},{"key":"view_f_2_7"},{"key":"view_f_2_8"}],"chans":[{"key":"view_f_3_1"},{"key":"view_f_3_2"}]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/viewers.json
// module id = 4JlK
// module chunks = 1